export default "__VITE_ASSET__242ee151__"